<template>
  <div class="box1">
    <!-- <img :src="test" alt="SVG Image" width="100%" height="100%" /> -->
    <Test1></Test1>
  </div>
</template>
<script>
import Test1 from '@/assets/test.svg?inline'
export default {
  name: 'SvgView',
  methods: {
    closeGraph() {
      this.showGraph = !this.showGraph
    }
  },
  components: {
    Test1
  },
  mounted() {},
  created() {
    this.$request(
      '/api/getWeather/forecast?latitude=39.9042&longitude=116.4074&hourly=temperature_2m'
    )
      .then(async (res) => {
        console.log('getWeather', res)
      })
      .catch((error) => {
        console.error(error)
      })
    this.$request('/api/getArticle')
      .then(async (res) => {
        console.log('getArticle', res)
      })
      .catch((error) => {
        console.error(error)
      })
  },
  data() {
    return {
      // test: test1
    }
  }
}
</script>
<style scoped lang="less"></style>
